




























































































































































































































































































import ApplicationModule from "@/store/modules/application";
import AppSelect from "@/components/global/ApplicationSelect.vue";
import {
  ApplicationState,
  SavedSearchPayload,
  CurrentSelectedFilters,
  FilterPayload,
  PriceOptimizerState,
  SavedSearch,
  SavedSearchFilter
} from "@/models";
import PriceOptimizerModule from "@/store/modules/price-optimizer";
import SnackbarModule from "@/store/modules/snackbar";
import FilterOptions from "@/views/price-optimizer/partials/FilterOptions.vue";
import FilterChips from "@/views/price-optimizer/partials/FilterChips.vue";
import UnitTypesTable from "@/views/price-optimizer/components/UnitTypesTable.vue";
import moment from "moment";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import { AuthState } from "@storage360/login/src/interfaces/auth-state";
import { formatDate } from "@/helpers/functions/format-date";

const application = namespace(ApplicationModule.name);
const priceOptimizer = namespace(PriceOptimizerModule.name);
const snackbar = namespace(SnackbarModule.name);

@Component({
  name: "PriceOptimizerSearch",
  components: { AppSelect, FilterChips, FilterOptions, UnitTypesTable }
})
export default class PriceOptimizerSearch extends Vue {
  // ===== Store ===== //
  @State("application") private readonly application!: ApplicationState;
  @State("auth") private auth!: AuthState;
  @State("priceOptimizer") private priceOptimizer!: PriceOptimizerState;
  @application.Action("getFacilityUnitTypes") public getFacilityUnitTypes!: () => void;
  @priceOptimizer.Action("addNewFilter") public addNewFilter!: () => void;
  @priceOptimizer.Action("applyFilters") public applyFilters!: (payload: object) => void;
  @priceOptimizer.Action("clearState") public clearState!: () => void;
  @priceOptimizer.Action("createSavedSearch") public createSavedSearch!: (payload: SavedSearchPayload) => void;
  @priceOptimizer.Action("deleteSavedSearch") public deleteSavedSearch!: (searchId: number) => void;
  @priceOptimizer.Action("endCustomLoadingState") public endCustomLoadingState!: (message: string) => void;
  @priceOptimizer.Action("getSavedSearches") public getSavedSearches!: () => void;
  @priceOptimizer.Action("removeSelectedFilter") public removeSelectedFilter!: (newVal: number) => void;
  @priceOptimizer.Action("commitResetCurrentSelectedFilters") public commitResetCurrentSelectedFilters!: () => void;
  @priceOptimizer.Action("commitSetFilterStartDate") public commitSetFilterStartDate!: (newVal: string) => void;
  @priceOptimizer.Action("commitSetFilterEndDate") public commitSetFilterEndDate!: (newVal: string) => void;
  @priceOptimizer.Action("selectSavedFilters") public selectSavedFilters!: (filters: SavedSearchFilter[]) => Promise<void>;
  @priceOptimizer.Action("setCustomLoadingState") public setCustomLoadingState!: (message: string) => void;
  @priceOptimizer.Action("updateSavedSearch") public updateSavedSearch!: (payload: SavedSearchPayload) => void;
  @snackbar.Action("errorMessage") public errorMessage!: (message: string) => void;

  // ===== Data ===== //
  public addFilterClicked = false;
  public alertStatus = false;
  public endDateMenu = false;
  public savedSearchId = 0;
  public searchName = "";
  public selectedSavedSearch: SavedSearch | null = null;
  public startDateMenu = false;
  public toggleDelete = false;

  // ===== Methods ===== //
  public formatDate = formatDate;
  public handleNewFilter(): void {
    this.addFilterClicked = true;
    this.addNewFilter();
  }

  public handleSavedFilters(savedSearch: SavedSearch): void {
    this.addFilterClicked = true;
    this.alertStatus = savedSearch.alert;
    this.savedSearchId = savedSearch.id;
    this.searchName = savedSearch.name;
    this.selectSavedFilters(savedSearch.filters);
  }

  /* istanbul ignore next */
  public async handleApplyFilters(showLoadState = true) {
    const joinedFilters = this.priceOptimizer.currentSelectedFilters.map(filter => {
      if (filter.type_selected.parameter === "last_move_in_at") {
        filter.last_rental_date = moment().utc()
          .subtract(filter.number_selected, "days").endOf("day").format("YYYY-MM-DD");
      } else if (filter.type_selected.value === "Competitor Pricing Change +/-") {
        filter.type_selected.parameter = filter.comp_price_selected.parameter;
      } else if (filter.type_selected.value === "Facility Location") {
        filter.number_selected = filter.location_selected.location_code;
      }

      const paramDiff = filter.comp_price_selected.parameter !== ""
        ? filter.comp_price_selected.parameter : filter.type_selected.parameter;

      const valueDiff = this.getFilterValue(filter);

      const gpiDate = filter.gpi_date !== "" ? `&previous_revenue_gpi_date=${filter.gpi_date}` : "";

      const dateRange = filter.type_selected.parameter !== "revenue_gpi_pct"
        ? `&date[gte]=${this.priceOptimizer.filterStartDate}&date[lte]=${this.priceOptimizer.filterEndDate}` : "";

      return `${paramDiff}${filter.symbol_selected.filter}=${valueDiff}${dateRange}${gpiDate}`;
    }).join("&");

    const payload: FilterPayload = {
      refresh: showLoadState,
      parameters: joinedFilters,
      date: this.priceOptimizer.currentDate
    };

    this.applyFilters(payload);
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  public getFilterValue(filter: any) {
    if (filter.last_rental_date !== undefined &&
        filter.last_rental_date !== ""
    ) {
      return filter.last_rental_date;
    }

    if (filter.location_selected !== undefined &&
        filter.location_selected.location_code !== undefined &&
        filter.location_selected.location_code !== ""
    ) {
      return filter.location_selected.location_code;
    }

    if (filter.std_rate !== undefined &&
        filter.std_rate !== ""
    ) {
      return filter.std_rate;
    }

    if (filter.unit_type_names && filter.unit_type_names.length > 0) {
      return JSON.stringify(filter.unit_type_names.map(
        function(x: string) { return encodeURI(x); }
      ));
    }

    return filter.number_selected;
  }
  /* eslint-enable @typescript-eslint/no-explicit-any */

  /* istanbul ignore next */
  public async cancelFilter(id: number): Promise<void> {
    await this.removeSelectedFilter(id);

    if (this.priceOptimizer.currentSelectedFilters && this.priceOptimizer.currentSelectedFilters.length === 0) {
      this.clearAllFilters();
    } else {
      await this.handleApplyFilters();
    }
  }

  public clearAllFilters(): void {
    this.addFilterClicked = false;
    this.alertStatus = false;
    this.savedSearchId = 0;
    this.searchName = "";
    this.commitResetCurrentSelectedFilters();
  }

  public async handleSavedSearch(): Promise<void> {
    let originalSearchName = "";
    if (this.savedSearchId) {
      originalSearchName = this.priceOptimizer.savedSearches.find(search => {
        return search.id === this.savedSearchId;
      })!.name;
    }
    const payload: SavedSearchPayload = {
      user_id: this.auth.profile.id,
      search_id: this.savedSearchId,
      name: this.searchName,
      alert: this.alertStatus,
      filters: this.formattedSavedSearchFilters
    };
    try {
      const response = this.savedSearchId
        ? await this.updateSavedSearch(payload)
        : await this.createSavedSearch(payload);
      const typedResponse = response as unknown;
      this.savedSearchId = typedResponse as number;
    } catch (err) {
      this.searchName = originalSearchName;
    }
  }

  public async loadSavedSearchAlert(): Promise<void> {
    this.savedSearchId = this.priceOptimizer.savedSearchId;
    await this.getSavedSearches();
    await this.commitSetFilterStartDate(moment.utc().subtract("30", "days").format("YYYY-MM-DD"));
    await this.commitSetFilterEndDate(moment.utc().format("YYYY-MM-DD"));
    this.selectedSavedSearch = this.priceOptimizer.savedSearches.find(savedSearch => {
      return savedSearch.id === this.priceOptimizer.savedSearchId;
    })!;
    await this.handleSavedFilters(this.selectedSavedSearch);
    await this.handleApplyFilters();
    this.endCustomLoadingState("getting saved search alert");
  }

  public async handleDeleteSavedSearch(): Promise<void> {
    await this.deleteSavedSearch(this.savedSearchId);
    this.clearAllFilters();
    this.toggleDelete = false;
  }

  /* istanbul ignore next */
  public generateGpiDateFilter(filter: CurrentSelectedFilters): SavedSearchFilter {
    return {
      filter_option_id: filter.id,
      operator: "eq",
      parameter: "previous_revenue_gpi_date",
      value: filter.gpi_date
    };
  }
  // ===== Watch ===== //
  @Watch("priceOpCurrentSelectedFilters")
  public clearName(filtersSelected: boolean) {
    if (!filtersSelected) {
      this.searchName = "";
      this.selectedSavedSearch = null;
      this.savedSearchId = 0;
    }
  }
  // ===== Computed ===== //
  get displayFilters(): boolean {
    return (
      !!this.priceOptimizer.currentSelectedFilters.length &&
      this.addFilterClicked &&
      !this.priceOptimizer.filtersApplied
    );
  }

  get filterStartDate(): string {
    return this.priceOptimizer.filterStartDate;
  }

  /* istanbul ignore next */
  set filterStartDate(newVal: string) {
    this.commitSetFilterStartDate(newVal);
  }

  get filterEndDate(): string {
    return this.priceOptimizer.filterEndDate;
  }

  /* istanbul ignore next */
  set filterEndDate(newVal: string) {
    this.commitSetFilterEndDate(newVal);
  }

  get formattedStartDate(): string {
    return this.formatDate(this.priceOptimizer.filterStartDate);
  }

  get formattedEndDate(): string {
    return this.formatDate(this.priceOptimizer.filterEndDate);
  }

  get priceOpCurrentSelectedFilters(): boolean {
    return !!(this.priceOptimizer.currentSelectedFilters && this.priceOptimizer.currentSelectedFilters.length);
  }

  /* istanbul ignore next */
  get filteredPriceOpTable(): boolean {
    return !!(this.priceOptimizer.filtersApplied && this.priceOptimizer.filteredUnits && this.priceOptimizer.filteredUnits.length);
  }

  get minDate(): string {
    return moment().utc().month(0).date(1).year(2018).format("YYYY-MM-DD");
  }

  get formattedSavedSearchFilters(): SavedSearchFilter[] {
    let gpiFilters: SavedSearchFilter[] = [];
    const selectedFilters = this.priceOptimizer.currentSelectedFilters;
    const standardFilters = selectedFilters.map((currentFilter: CurrentSelectedFilters) => {
      let value;
      value = currentFilter.number_selected;
      if (currentFilter.type_selected.value === "Facility Location" && currentFilter.location_selected.location_code) {
        value = currentFilter.location_selected.location_code;
      } else if (currentFilter.type_selected.value === "Standard Rate") {
        value = currentFilter.std_rate;
      } else if (currentFilter.type_selected.parameter === "unit_type_name") {
        value = currentFilter.unit_type_names;
      }
      return {
        filter_option_id: currentFilter.id,
        operator: currentFilter.symbol_selected.filter.replace(/[^\w\s]/gi, ""),
        parameter: currentFilter.type_selected.parameter,
        value
      };
    });
    /* istanbul ignore next */
    if (selectedFilters.find((filter: CurrentSelectedFilters) => filter.gpi_date)) {
      /* istanbul ignore next */
      gpiFilters = selectedFilters.map((filter: CurrentSelectedFilters) => this.generateGpiDateFilter(filter));
    }
    return standardFilters.concat(
      gpiFilters.filter(
        (filter: SavedSearchFilter) => filter.value
      )
    );
  }

  get allFiltersValid(): boolean {
    const typeAccepted = this.priceOptimizer.currentSelectedFilters.every(filter => filter.type_selected.value);
    const symbolAccepted = this.priceOptimizer.currentSelectedFilters.every(filter => filter.symbol_selected.filter);
    return (
      typeAccepted &&
      symbolAccepted &&
      this.facilityAccepted &&
      this.valueAccepted &&
      this.unitTypeNamesAccepted
    );
  }

  get valueAccepted(): boolean {
    const nonDropdownFilter = this.priceOptimizer.currentSelectedFilters.filter(facility => {
      return (
        facility.type_selected.value !== "Facility Location" &&
        facility.type_selected.parameter !== "unit_type_name"
      );
    });
    return nonDropdownFilter.every(filter => {
      const selected = filter.number_selected;
      const stdRate = filter.std_rate;
      return ((typeof selected === "number" && selected > -1) || selected || stdRate);
    });
  }

  get facilityAccepted(): boolean {
    const facilityFilter = this.priceOptimizer.currentSelectedFilters.filter(facility => {
      return facility.type_selected.value === "Facility Location";
    });
    return facilityFilter.every(facility => facility.location_selected.location_code !== "");
  }

  get unitTypeNamesAccepted(): boolean {
    const unitTypeNameFilter = this.priceOptimizer.currentSelectedFilters.filter(unitTypeName => {
      return unitTypeName.type_selected.parameter === "unit_type_name";
    });
    return unitTypeNameFilter.every(
      unitTypeName => (
        typeof unitTypeName.unit_type_names !== "undefined" &&
        unitTypeName.unit_type_names.length > 0
      )
    );
  }

  get checkboxLabel(): string {
    return this.alertStatus ? "Saved as custom alert(s) in Dashboard" : "Check to save as custom alert(s) in Dashboard";
  }

  get showSkeleton(): boolean {
    const loadState = this.priceOptimizer.loadingState;
    if (this.priceOptimizer.savedSearchId) {
      return loadState.includes("getting saved search alert") || loadState.includes("filtered units loading");
    }
    return false;
  }

  get canSaveOrUpdateSearch(): boolean {
    /* istanbul ignore next */
    return !!(this.allFiltersValid && this.searchName);
  }
  // ===== Lifecycle Hooks ===== //
  private created(): void {
    if (this.priceOptimizer.savedSearchId) {
      this.setCustomLoadingState("getting saved search alert");
    }
  }
  private mounted(): void {
    this.getFacilityUnitTypes();
    this.getSavedSearches();
    if (this.priceOptimizer.savedSearchId) {
      this.loadSavedSearchAlert();
    }
  }
  private beforeDestroy(): void {
    this.clearState();
  }
}
